import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

import SectionTitle from '../SectionTitle/SectionTitle';
import programsLogo from '../../assets/img/programs/class.svg';
import arrowIcon from '../../assets/img/arrow.svg';

import './Programs.css'

const programs = [
    {
        logo: programsLogo,
        title: 'برنامج قدراتك',
        info: 'تطوير المهارات التقنية للموظفين بالقطاع الحكومي بالمملكة العربية السعودية',
        date: '2016 - 2011',
        status: 'انتهى',
        backGround: require('../../assets/img/programs/program-1.png'),
        closed: true,
    },
    {
        logo: programsLogo,
        title: 'برنامج التدريب الإحترافي',
        info: 'دورات تدريبية احترافية للأخصائيين التقنيين بالقطاع الحكومي بالمملكة العربية السعودية',
        date: '2016 - 2015',
        status: 'انتهى',
        backGround: require('../../assets/img/programs/program-2.png'),
        closed: true,
    },
    {
        logo: require('../../assets/img/programs/hamat-logo.png'),
        title: 'مشروع تدريب القيادات الحكومية',
        info: 'تطوير قيادات التحول الرقمي في القطاع الحكومي في المملكة العربية السعودية',
        date: '2019 - Now',
        status: 'قائم',
        backGround: require('../../assets/img/programs/program-hamat.png'),
        closed: false,
    },
]

class Programs extends Component {


    renderProgram = (index) => {
        // two colmun at a time - the current and previous item
        let program = [programs[index - 1], programs[index]];

        if (programs[index - 1] !== undefined) {
            return (
                <div className="columns is-3 mt-5" key={index}>
                    {program.map((program, i) => {
                        const classClosed = program.closed ? 'closed' : ''
                        return (
                            <Fade duration={1000} delay={200} key={i}>
                                <div className="column" >
                                    <div className={`card ${classClosed}`}>
                                        <div className="card-icon">
                                            <figure className="card-header-icon image is-96x96 is-flex">
                                                <img src={program.logo} alt={program.info} />
                                            </figure>
                                        </div>
                                        <div className="card-image">
                                            <div className="card-overlay"></div>
                                            <div className="card-header has-text-centered">
                                                <h3 className="title is-5 has-text-white has-text-centered"> {program.title} </h3>
                                            </div>
                                            <figure className="image is-3by1">
                                                <img src={program.backGround} alt={program.info} />
                                            </figure>
                                        </div>
                                        <div className="card-content">
                                            <div className="content">
                                                <p>{program.info}</p>
                                                <br />
                                                <div className={`program-date ${classClosed}`}>
                                                    <time dateTime="2011"> {program.date}</time>
                                                    <span>{program.status}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <button className="button show-more">اقرأ المزيد <img src={arrowIcon} alt="" /></button>
                                    </div>
                                </div>
                            </Fade>
                        )
                    })
                    }
                </div>
            )
        }
    }
    render() {
        const lastProgram = programs[programs.length - 1]
        const classClosed = lastProgram.closed ? 'closed' : ''

        return (
            <section id="programs" className="section">
                <Fade>
                <SectionTitle>برامج الأكاديمية</SectionTitle>
                </Fade>


                <div className="container">
                    {programs.map((program, index) => {
                        // console.log(program)
                        return (
                            (index % 2) ?
                                this.renderProgram(index) :
                                (index === programs.length - 1) ?
                                    <div className="columns is-3 mt-5" key={index} >
                                        <Fade>
                                            <div className="column is-6" >
                                                <div className={`card ${classClosed}`}>
                                                    <div className="card-icon">
                                                        <figure className="card-header-icon image is-96x96 is-flex">
                                                            <img src={program.logo} alt={program.info} />
                                                        </figure>
                                                    </div>
                                                    <div className="card-image">
                                                        <div className="card-overlay"></div>
                                                        <div className="card-header has-text-centered">
                                                            <h3 className="title is-5 has-text-white has-text-centered"> {program.title} </h3>
                                                        </div>
                                                        <figure className="image is-3by1">
                                                            <img src={program.backGround} alt={program.info} />
                                                        </figure>
                                                    </div>
                                                    <div className="card-content">
                                                        <div className="content">
                                                            <p>{program.info}</p>
                                                            <br />
                                                            <div className={`program-date ${classClosed}`}>
                                                                <time dir="ltr" dateTime="2011"> {program.date}</time>
                                                                <span>{program.status}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <Link to={{ pathname: '/hamat-program', state: { url: 'other' }}} className='button show-more'>
                                                    اقرأ المزيد <img src={arrowIcon} alt="" />
                                                </Link> */}
                                                    <Link to='/hamat-program'
                                                        className='button show-more'
                                                        onClick={this.props.onChangePage}
                                                    >
                                                        اقرأ المزيد <img src={arrowIcon} alt="" />
                                                    </Link>

                                                </div>
                                            </div>
                                        </Fade>

                                    </div>
                                    :
                                    ''
                        )

                    })
                    }
                </div>
            </section >
        )
    }
}
export default Programs;